import PersonName from './PersonName';

export default PersonName;
